if (!customElements.get('product-card-gallery')) {
  customElements.define(
    'product-card-gallery',
    class ProductCardGallery extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.mediaCount = parseInt(this.dataset.mediaCount) || 0;
        this.images = this.querySelectorAll('.product-card-gallery__image');
        this.indicators = this.querySelectorAll('.product-card-gallery__indicator');
        this.prevButton = this.querySelector('.product-card-gallery__arrow--prev');
        this.nextButton = this.querySelector('.product-card-gallery__arrow--next');
        
        this.init();
      }

      init() {
        if (this.mediaCount <= 1) {
          return;
        }

        
        this.bindEvents();
        this.updateButtons();
      }

      bindEvents() {
        // Arrow button events
        if (this.prevButton) {
          this.prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.previousImage();
            return false;
          });
        }
        
        if (this.nextButton) {
          this.nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.nextImage();
            return false;
          });
        }

        // Indicator events
        this.indicators.forEach((indicator, index) => {
          indicator.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.goToImage(index);
            return false;
          });
        });

        // Keyboard navigation
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.previousImage();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.nextImage();
          }
        });

        // Touch/swipe support for mobile
        this.addTouchSupport();
      }

      addTouchSupport() {
        let startX = 0;
        let startY = 0;
        let endX = 0;
        let endY = 0;

        this.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        });

        this.addEventListener('touchend', (e) => {
          endX = e.changedTouches[0].clientX;
          endY = e.changedTouches[0].clientY;
          this.handleSwipe(startX, startY, endX, endY);
        });
      }

      handleSwipe(startX, startY, endX, endY) {
        const deltaX = endX - startX;
        const deltaY = endY - startY;
        const minSwipeDistance = 50;

        // Only handle horizontal swipes
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
          if (deltaX > 0) {
            this.previousImage();
          } else {
            this.nextImage();
          }
        }
      }

      nextImage() {
        if (this.mediaCount <= 1) return;
        
        this.currentIndex = (this.currentIndex + 1) % this.mediaCount;
        this.updateGallery();
      }

      previousImage() {
        if (this.mediaCount <= 1) return;
        
        this.currentIndex = this.currentIndex === 0 ? this.mediaCount - 1 : this.currentIndex - 1;
        this.updateGallery();
      }

      goToImage(index) {
        if (this.mediaCount <= 1 || index < 0 || index >= this.mediaCount) return;
        
        this.currentIndex = index;
        this.updateGallery();
      }

      updateGallery() {
        // Update images
        this.images.forEach((image, index) => {
          if (index === this.currentIndex) {
            image.classList.add('product-card-gallery__image--active');
          } else {
            image.classList.remove('product-card-gallery__image--active');
          }
        });

        // Update indicators
        this.indicators.forEach((indicator, index) => {
          if (index === this.currentIndex) {
            indicator.classList.add('product-card-gallery__indicator--active');
          } else {
            indicator.classList.remove('product-card-gallery__indicator--active');
          }
        });

        this.updateButtons();
      }

      updateButtons() {
        if (this.mediaCount <= 1) return;

        // Update prev button
        if (this.prevButton) {
          if (this.currentIndex === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
          } else {
            this.prevButton.removeAttribute('disabled');
          }
        }

        // Update next button
        if (this.nextButton) {
          if (this.currentIndex === this.mediaCount - 1) {
            this.nextButton.setAttribute('disabled', 'disabled');
          } else {
            this.nextButton.removeAttribute('disabled');
          }
        }
      }

      // Public method to reset gallery
      reset() {
        this.currentIndex = 0;
        this.updateGallery();
      }

      // Public method to get current image index
      getCurrentIndex() {
        return this.currentIndex;
      }

      // Public method to get total media count
      getMediaCount() {
        return this.mediaCount;
      }
    }
  );
}

// Initialize all product card galleries on page load
document.addEventListener('DOMContentLoaded', () => {
  initializeGalleries();
});

// Re-initialize galleries when new content is loaded (for AJAX/SPA scenarios)
document.addEventListener('shopify:section:load', () => {
  initializeGalleries();
});

function initializeGalleries() {
  const galleries = document.querySelectorAll('.product-card-gallery');
  
  galleries.forEach((gallery) => {
    // Only initialize if the gallery has more than 1 image
    const mediaCount = parseInt(gallery.dataset.mediaCount) || 0;
    
    if (mediaCount > 1) {
      // Check if already wrapped in custom element
      if (!gallery.closest('product-card-gallery')) {
        // Wrap the gallery in the custom element
        const wrapper = document.createElement('product-card-gallery');
        wrapper.setAttribute('data-media-count', mediaCount);
        gallery.parentNode.insertBefore(wrapper, gallery);
        wrapper.appendChild(gallery);
      }
    }
  });
}
